// import { Redirect } from "react-router-dom"
import { all, fork, takeEvery } from "redux-saga/effects"

// Watchers
function* collectionListSaga() {
	yield takeEvery("collection_list/getCollection", getAllCollectionList)
}

// Sagas
function* getAllCollectionList(action) {
        // console.log(action, 'from collection saga');
    // try {
    //     console.log(action, 'from collection saga')
	// 	 yield put(getCollectionList(action.payload))
	// } catch (error) {
	// 	yield put(getErrors(error))
	// }
}

export default function* rootSaga() {
	yield all([fork(collectionListSaga)])
}
